export const mimeTypes = {
  'application/pdf': ['pdf'],
  'application/msword': ['doc'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
    'docx'
  ],
  'application/vnd.ms-excel': ['xls'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['xlsx'],
  'image/png': ['png'],
  'image/jpeg': ['jpeg', 'jfif'],
  'image/gif': ['gif'],
  'image/tiff': ['tif'],
  'application/vnd.ms-powerpoint': ['ppt'],
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': [
    'pptx'
  ],
  'application/vnd.ms-powerpoint.presentation.macroEnabled.12': ['pptm'],
  'text/plain': ['txt']
};
